import { render, staticRenderFns } from "./TransfersChannelForm.vue?vue&type=template&id=ff0a527a&scoped=true"
import script from "./TransfersChannelForm.vue?vue&type=script&lang=js"
export * from "./TransfersChannelForm.vue?vue&type=script&lang=js"
import style0 from "./TransfersChannelForm.vue?vue&type=style&index=0&id=ff0a527a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff0a527a",
  null
  
)

export default component.exports